module.exports = __webpack_public_path__ + "img/32839895314_0a0469c65e_w.ad0d5c9a.jpg";